import React from 'react'
import SiteContent from './SiteContent'
import SiteFooter from './SiteFooter'
import SiteHeader from './SiteHeader'

const SiteLayout = () => {

  return (
    <div>
      <SiteHeader />
      <SiteContent />
      <SiteFooter />
    </div>
  )
}

export default SiteLayout